const hasSpan = (note) => note.top_height != null;

export { hasSpan };
